import { render, staticRenderFns } from "./SupportHome.vue?vue&type=template&id=241a2e3b&scoped=true"
import script from "./SupportHome.vue?vue&type=script&lang=js"
export * from "./SupportHome.vue?vue&type=script&lang=js"
import style0 from "./SupportHome.vue?vue&type=style&index=0&id=241a2e3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241a2e3b",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QSeparator});
